<template>
	<div class="flex flex_column">
		<div class="flex flex_column modal-content">
			<RevolvingPutOptionShortInfo :option-data="optionData"/>
			<div class="margin_top">
				<h4 class="info_title small_margin">{{$t('common.receivables')}}</h4>
				<RevolvingPutOptionSoldReceivablesTable :list-func="(postData) => soldReceivablesFunc(optionData, postData)"/>
			</div>
		</div>
		<div class="flex flex_end margin_top">
			<md-button class="md-blank" @click.stop="closeNoticeModal">{{ $t('common.close') }}</md-button>
		</div>
	</div>
</template>

<script>

import RevolvingPutOptionSoldReceivablesTable
	from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionSoldReceivablesTable";
import {mapGetters} from "vuex";
import RevolvingPutOptionShortInfo from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionShortInfo";

export default {
	components: {
		RevolvingPutOptionShortInfo,
		RevolvingPutOptionSoldReceivablesTable
	},
	data() {
		return {

		};
	},
	computed: {
		...mapGetters({ noticeModalData: "noticeModalData" }),
		optionData() {
			return this.noticeModalData.data.revolvingPutOption;
		},
		soldReceivablesFunc() {
			return this.noticeModalData.data.soldReceivablesFunc;
		},
	},
	methods: {
		closeNoticeModal() {
			this.$store.dispatch("setActionNoticModal", { show: false, data: {} });
		},
	},
};
</script>